export class SupportTicketsModel {
    id: number;
    OwnerUid: string;
    Name: string;
    Subject: string;
    Message: string;
    Category: string;
    Status: number;
    Priority: number;
    Resolved: boolean;
    Date: Date;
}
